exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-form-item {\n  margin-bottom: 2px !important;\n}\n.title {\n  padding: 4px 0 4px 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: cornflowerblue;\n  font-family: \"Comic Sans MS\", cursive, sans-serif;\n  text-align: center;\n}\n", "", {"version":3,"sources":["/home/travis/build/kuzank/vue-code-diff/src/App.vue"],"names":[],"mappings":";AACA;EACE,8BAA8B;CAC/B;AACD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kDAAkD;EAClD,mBAAmB;CACpB","file":"App.vue","sourcesContent":["\n.el-form-item {\n  margin-bottom: 2px !important;\n}\n.title {\n  padding: 4px 0 4px 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: cornflowerblue;\n  font-family: \"Comic Sans MS\", cursive, sans-serif;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27b3a9b4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 416
// module chunks = 1